import AuthService from './AuthService';
import ApiService from "./ApiService";

class ImagesService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this._deleteProductUrl = '/profile/products/delete/image';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    removeProductImage(params) {
        return this.postResource(this._deleteProductUrl, params, this.getBaseHeaders());
    }
}

const service = new ImagesService(AuthService);

export default service;
